<template>
  <v-container fluid>
    <alert-error :error="error"></alert-error>
    <v-toolbar>
      <v-toolbar-title>{{ $t('ORDERS.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="pa-5" tile>
      <orders-filter @setFilters="setFilters" />
      <orders-list
        :items="items"
        :meta="meta"
        :options.sync="options"
        @show="show"
      />
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getViewRouteNameByOrderType } from '@/modules/orders/common/utils';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'OrdersPage',

  components: {
    OrdersList: () => import('../components/OrdersList'),
    OrdersFilter: () => import('../components/forms/OrdersFilterForm'),
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  mixins: [listOptions],

  data() {
    return {
      error: null,
      options: {
        page: 1,
        itemsPerPage: 100,
        sortBy: ['date_entered'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      }
    };
  },

  computed: {
    ...mapState('order', ['paginationOptions'])
  },

  methods: {
    ...mapActions('order', ['getItemsList']),

    show(item) {
      const routeName = getViewRouteNameByOrderType(item.type_id);

      if (routeName) {
        this.$router.push({
          name: routeName,
          params: { id: item.id }
        });
      }
    }
  }
};
</script>
